import { render, staticRenderFns } from "./FloatDate.vue?vue&type=template&id=48d4fed3"
import script from "./FloatDate.vue?vue&type=script&lang=js"
export * from "./FloatDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports